export const TableCellContentTypes = {
  OWNER: {
    subcontractor: 'Alihankkija',
    vertia: 'Vertia',
  },
}
